/**
 * Query keys, werden für @tanstack/vue-query verwendet um queries zu cachen
 */
export enum QueryKeys {
    /*----- general queries-----*/
    MANDANT_LIST = "mandant-list",
    /*----- module zew queries -----*/
    TIME_RECORDS_HISTORY = "timerecords-history",
    TIME_RECORDS_CURRENT = "timerecords-current",
    TIME_RECORDS_SALDO_TODAY = "timerecords-saldo-today",
    ABSENCES_HISTORY = "absences-history",
    EXPENSES_HISTORY = "expenses-history",
    /*----- module ToDo queries -----*/
    TODO_LOGS = "todo-logs",
    TODO_LOGS_COLLECTION = "todo-logs-collection",
    TODO_LOGS_ALL = "todo-logs-all",
    TODO_LOGS_MONTHLY = "todo-logs-monthly",
    TODO_LOGS_MONTHLY_DATES = 'todo-logs-monthly-dates',
    TODO_LOGS_DETAIL = 'todo-logs-detail',
    TODO_LOGS_TASKS_CACHE = "todo-logs-tasks-cache",
    TODO_LOGS_REPORTS_CACHE = "todo-logs-reports-cache",
    TODO_LOGS_TASKS_DETAIL = 'todo-logs-tasks-detail',
    TODO_LOGS_DOCUMENTS_DETAIL = 'todo-logs-documents-detail',
    TODO_LOGS_DOCUMENTS_DETAIL_FILE = 'todo-logs-documents-detail-file',

    /*----- notifications queries -----*/
    HAS_NOTIFICATIONS = "has-notifications",
    USER_NOTIFICATIONS = "user-notifications",
    ABSENCES_PENDING = "absences-pending",
    EXPENSES_PENDING = "expenses-pending",
    /*----- admin queries -----*/
    ADMIN_MANDANT_ROLES = "admin-mandant-roles",
    ADMIN_MANDANT_USERS = "admin-mandant-users",
    ADMIN_MANDANT_DIVISIONS = "admin-mandant-divisions",
}
